import { Box, TextField } from '@mui/material';
import { Text } from 'mbd-components/text';

export function EditableTextField({heading, multiline, rows, value, onChange, horizontal}) {

  return (
    <Box  mr={4} mt={4} sx={{display:'flex', flexDirection: horizontal ? 'row' : 'column', alignItems: horizontal ? 'center' : 'flex-start'}} fullWidth width='100%' >
      <Text variant='fieldHeading' color='brand-light' sx={{minWidth: 80}}>
        {heading}
      </Text>
      <TextField 
        fullWidth
        multiline={multiline ? true : false}
        rows={rows ? rows : 1}
        value={value} 
        onChange={onChange} 
        variant="outlined" 
        sx={{marginLeft: horizontal ? 2 : 0, marginTop: horizontal ? 0 : 2}} 
      />
    </Box>
  );
}